import React from 'react';


const About = () => {
  return (
    <div className="about-us-container">
      {/* Photo Section */}
      <div className="photo-section">
        <div className="photo left-photo">
          <img
            src="WhatsApp Image 2024-12-03 at 10.18.57_be0132f4.jpg"
            alt="Founder Photo 1"
            className="photo-img"
          />
        </div>

        {/* Content Section */}
        <div className="content">
          <section className="founder-message">
            <p className="message-text">
              पिछले 24 साल से आप सब के सहयोग ओर स्नेह से रामा शिक्षा समिति कुतबपुर ने शिक्षा, चिकत्सा, खेल-कूद के क्षेत्र में विभिन्न व्यवसायिक एवं शैक्षिणिक संस्थानों के माध्यम से आप सब से जुड़ने और युवाओं तथा बच्चों के सुनहरे भविष्य की दिशा में कुछ महत्वपूर्ण कदम उठाएं हैं। रामा ग्रुप ऑफ इन्सटीच्यूट की स्थापना 1999 में हुई थीं जिसमें निम्न संस्थाएं अपनी सेवाएं दे रही हैं:
            </p>

            {/* Horizontally aligned list */}
            <div className="horizontal-list">
              <span>रामा सी. सै. स्कूल, कुतबपुर</span>
              <span>रामा कॉलेज ऑफ नर्सिंग, कुतबपुर</span>
              <span>रामा कॉलेज ऑफ एजूकेशन, कुतबपुर</span>
              <span>रामा प्राइवेट आई. टी. आई., कुतबपुर</span>
            </div>

            <p className="message-text">
              सन् 2014 में NH-65 कैथल-हिसार रोड़ पर गांव बात्ता में युवराज इन्सटीच्यूट की स्थापना की गई। जिसमें प्रथम वर्ष से ही आप-पास के कई गांव इस मिशन में हमारा साथ जुड़े और अपने बच्चों के उज्जवन भविष्य के लिए युवराज संस्थान पर अपना विश्वास दिखाया जिस पर पिछले 9 वर्षों से संस्थान खरा भी उतर रहा है रामा शिक्षा समिति और ट्रैस्ट का राष्ट्रीय लक्ष्य है:
            </p>
            <div className="centered quotes">
              <p>“EDUCATION FOR ALL”</p>
              <p>“HEALTH FOR ALL”</p>
              <p>“SPORTS FOR ALL”</p>
            </div>
            <p className="message-text">
              युवराज इन्सीटच्यूट अपने जिले की एकमात्र संस्थान जहां B.P.Ed., MPHW (Male) & D.Pharma कोर्स करवाया जाता है। हर वर्ष एक-एक कदम आगे बढ़ाते हुए इस वर्ष भी रामा व युवराज इन्सटीच्यूट अभिभावकों के समक्ष उपस्थित हैं। जिसमें निम्न संस्थाएं अपनी सेवाएं दे रही हैं:
            </p>
            <ul className="services-list">
              <li>युवराज पब्लिक स्कूल, वात्ता</li>
              <li>युवराज एम.पी. एच. डब्लयू (मेल) ट्रेनिंग स्कूल, बात्ता</li>
              <li>युवराज कॉलेज ऑफ फिजिकल एजुकेशन, बात्ता</li>
              <li>युवराज प्राइवेट आई.टी.आई., बात्ता</li>
              <li>युवराज कॉलेज ऑफ फार्मेसी, बात्ता (डी-फार्मेसी)</li>
            </ul>
            <p className="message-text">
              अपनी मेहनती टीम और बहुमुखी व्यक्तित्व निर्माण के नजिरए के साथ आप सब के सहयोग के आकांक्षी।
            </p>
          </section>
        </div>

        <div className="photo right-photo">
          <img src="img_f.jpg" alt="Founder Photo 2" className="photo-img" />
        </div>
      </div>
    </div>
  );
};

export default About;
